module.exports = __webpack_public_path__ + "img/gohealth.9c9acfbc.png";